import { Component, Inject } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-flamingo-snackbar-loader',
  template: `
    <div style="display: flex">
      <span>{{ data.message }}</span>
      <span style="flex-grow: 1"></span>
      <mat-progress-spinner mode="indeterminate" color="accent" diameter="18"></mat-progress-spinner>
    </div>
  `,
  imports: [
    MatProgressSpinner,
  ],
})
export class SnackBarLoaderComponent {

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {

  }

}
